import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { editStateOfficeStatus } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import { OfficeStatusType } from "../types";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";

const OfficeStatusDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: OfficeStatusType | undefined;
}) => {
  // Props drilled
  const { setChanges, data } = props;

  // Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission = userPermissions.includes(
    PERMISSIONS.permission_utilities_officeconfiguration_officestatus_edit
  );

  // Recoil Hook
  const edit = useRecoilValue(editStateOfficeStatus);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local State
  const [inputData, setInputData] = useState(data?.status || "");
  const [inputData2, setInputData2] = useState(data?.description || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  // Event Handlers

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputData(e.target.value);
    if (
      e.target.value.trim() === "" ||
      (e.target.value === data?.status &&
        inputData2 === data?.description &&
        checkBoxChanges === data?.isActive) ||
      inputData2.trim() === ""
    ) {
      setChanges(false);
    } else {
      setChanges(true);
    }
    e.target.value = e.target.value.replace(/\s+/g, " ");
  };

  const handleInputChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputData2(e.target.value);
    if (
      e.target.value.trim() === "" ||
      (e.target.value === data?.description &&
        inputData === data?.status &&
        checkBoxChanges === data?.isActive) ||
      inputData.trim() === ""
    ) {
      setChanges(false);
    } else {
      setChanges(true);
    }
    e.target.value = e.target.value.replace(/\s+/g, " ");
  };
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!deletePermission && data?.isActive) return;
    setCheckBoxChanges(e.target.checked);

    if (
      inputData?.length === 0 ||
      (e.target.checked === data?.isActive && inputData === data?.status)
    ) {
      setChanges(false);
    } else {
      setChanges(true);
    }
  };

  return (
    <div className="bg-bgDB">
      <div className="m-2 bg-white shadow-lg h-full">
        <div className="grid grid-cols-1 md:grid-cols-3 p-2 gap-2 place-items-center">
          <div className="px-1 mx-1 w-full">
            <TextInputLabelHookForm
              name="status"
              label="Status Name"
              type="text"
              onChange={(e) => {
                handleInputChange(e);
              }}
              required={true}
              className={
                formMethods.formState.errors.status &&
                formMethods.formState.errors.status.message &&
                "border-2 border-red-500 col-span-2 "
              }
              register={formMethods.register("status", {
                required: {
                  value: true,
                  message: "Required Field",
                },
              })}
              maxLength={150}
            />
          </div>
          <div className="px-3 mx-2 w-full">
            <TextInputLabelHookForm
              name="description"
              label="Description"
              type="text"
              onChange={(e) => {
                handleInputChange2(e);
              }}
              required={true}
              className={
                formMethods.formState.errors.description &&
                formMethods.formState.errors.description.message &&
                "border-2 border-red-500 col-span-2 "
              }
              register={formMethods.register("description", {
                required: {
                  value: true,
                  message: "Required Field",
                },
              })}
              maxLength={150}
            />
          </div>
          {edit && (
            <div className="px-3 mx-2 w-full">
              <CheckBoxLabelHookForm
                name="isActive"
                label={
                  checkBoxChanges
                    ? "Uncheck to Deactivate"
                    : "Check to Activate"
                }
                type="checkbox"
                validation={{
                  required: { value: false, message: "Required Field" },
                }}
                onClick={(e) => {
                  handleCheckboxChange(e);
                }}
                disabled={!deletePermission && data?.isActive ? true : false}
                register={register}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfficeStatusDetails;
